module.exports = __webpack_public_path__ + "img/choithrams-original-480.f848928d.webp";